import { render, staticRenderFns } from "./LayoutAssessment.vue?vue&type=template&id=2d2183f2&scoped=true&"
import script from "./LayoutAssessment.vue?vue&type=script&lang=js&"
export * from "./LayoutAssessment.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAssessment.vue?vue&type=style&index=0&id=2d2183f2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2183f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VFooter,VMain,VSpacer})
